import { Accordion as LibAccordion, Typography } from "@mui/material";

import styled from "styled-components";

export const Accordion = styled(LibAccordion)`
  && {
    border: 1px solid rgba(255, 255, 255, 0.04);
    background: rgba(255, 255, 255, 0.03);
    border-radius: 8px !important;
    margin-bottom: 12px !important;

    &.Mui-expanded {
      margin-bottom: 12px !important;
    }

    &::before {
      display: none;
    }

    .MuiAccordionSummary-root {
      min-height: 44px;
      padding: 0 16px;

      &.Mui-expanded {
        min-height: 44px;
      }

      .MuiAccordionSummary-content {
        margin: 10px 0;
        &.Mui-expanded {
          margin: 10px 0;
        }
      }

      .MuiAccordionSummary-expandIconWrapper {
        color: #ac8d75;
        transform: rotate(0deg);
        transition: transform 0.3s ease;

        &.Mui-expanded {
          transform: rotate(180deg);
        }
      }
    }

    .MuiAccordionDetails-root {
      padding: 0 16px 14px;
    }
  }
`;

export const AccordionTitle = styled(Typography)<{ isDisabled: boolean }>`
  font-family: "Raleway", sans-serif;
  font-size: 0.75rem;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  color: #e0d2c1;

  ${({ isDisabled }) => isDisabled && "opacity: 0.2"}
`;
